import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { TextInput, MultiSelect, ArrayInput, CheckBox } from '@components/form';
import { Button, Row, Col } from 'antd';
import { cities } from '@utils/usStates';
import PropertyActions, {
  PropertySelectors,
  PROPERTY_STEPS
} from '@redux/PropertyRedux';

import validationSchema from './schema';

function PropertyBasicForm(props) {
  const { propertyBasicInfo, onSubmit } = props;

  const handleSubmit = (values, actions) => {
    const { setSubmitting } = actions;
    setSubmitting(true);
    onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={propertyBasicInfo}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      isInitialValid={validationSchema.isValidSync(propertyBasicInfo)}
      render={({ isValid, isSubmitting, setFieldValue, values }) => {
        const { isBuildingRequired } = values;
        return (
          <Form className="create-form ant-form-vertical">
            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={TextInput}
                  mb={4}
                  name="name"
                  type="text"
                  label="Property Name"
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={TextInput}
                  mb={4}
                  name="address"
                  type="text"
                  label="Street Address"
                />
              </Col>
            </Row>
            <Row justify="space-between" gutter={16}>
              <Col span={8}>
                <Field
                  component={MultiSelect}
                  mb={4}
                  showSearch
                  name="city"
                  mode="single"
                  type="text"
                  label="City"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={cities}
                  onChange={cityValue => {
                    const state = cityValue ? cityValue.split('_').pop() : '';
                    setFieldValue('state', state);
                    setFieldValue('city', cityValue);
                  }}
                />
              </Col>
              <Col span={6}>
                <Field
                  component={TextInput}
                  mb={4}
                  name="state"
                  readOnly
                  type="text"
                  label="State"
                />
              </Col>

              <Col span={6}>
                <Field
                  component={TextInput}
                  mb={4}
                  name="zipcode"
                  type="text"
                  label="Zip Code"
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={TextInput}
                  mb={4}
                  name="unitsCount"
                  type="number"
                  label="Units Count"
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={MultiSelect}
                  name="bedroomsCounts"
                  options={[
                    { label: 'Studio', value: '0' },
                    { label: '1', value: '1' },
                    { label: '2', value: '2' },
                    { label: '3', value: '3' },
                    { label: '4', value: '4' }
                  ]}
                  mode="multiple"
                  label="No of bedrooms"
                />
              </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: 20 }}>
              <Col span={10}>
                <Field
                  component={CheckBox}
                  name="isBuildingRequired"
                  type="email"
                  label="Buildings required"
                  minLen={1}
                  gutter={16}
                />
              </Col>
            </Row>

            {isBuildingRequired && (
              <Row gutter={16}>
                <Col span={10}>
                  <Field
                    component={ArrayInput}
                    name="buildingsNames"
                    type="text"
                    label="Building names"
                    innerLabel="Building name"
                    minLen={2}
                    gutter={16}
                  />
                </Col>
              </Row>
            )}

            <Row type="flex" className="action-btns">
              <Button
                type="primary"
                htmlType="submit"
                disabled={!isValid || isSubmitting}
              >
                Next
              </Button>
            </Row>
          </Form>
        );
      }}
    />
  );
}

PropertyBasicForm.propTypes = {
  propertyBasicInfo: PropTypes.object,
  onSubmit: PropTypes.func,
  onNext: PropTypes.func,
  initialFormValues: PropTypes.object
};

const mapStateToProps = state => ({
  propertyBasicInfo: PropertySelectors.selectBasicInfo(state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    dispatch(PropertyActions.setPropertyBasicInfo(values));
    dispatch(PropertyActions.setPropertyStep(PROPERTY_STEPS.MORE_INFO));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyBasicForm);
